import gameConfig from '../config/gameConfig'

export const EMPTY = 0
export const BLACK = 1
export const WHITE = 2

export const OPPONENT = {
  [BLACK]: WHITE,
  [WHITE]: BLACK,
}

/** 8 方向偏移 */
export const DIRECTIONS = [
  [-1, -1], [-1, 0], [-1, 1],
  [0, -1],           [0, 1],
  [1, -1],  [1, 0],  [1, 1],
]

export const ALLOWED_BOARD_SIZES =
  gameConfig.board.allowedSizes ?? [4, 5, 6, 7, 8, 9, 10, 11, 12]

export function isValidBoardSize(n) {
  return Number.isInteger(n) && ALLOWED_BOARD_SIZES.includes(n)
}